<style lang="scss">

</style>

<!-- eslint-disable -->
<template>
  <b-card no-body class="mb-0">
    <div class="full-width d-flex mb-1">
      <p class="font-weight-bolder">User Feedback List</p>
      <div class="ui-spacer"></div>
      <b-button :class="{'disabled': reportLoading}" @click="createReport()">Download CSV</b-button>
    </div>


    <b-table
      :responsive="true"
      class="data-table"
      hover
      :items="feedback"
      :current-page="currentPage"
      :per-page="-1"
      :fields="headers">
      <template #cell(name)="data">
        <p class="link-style" @click="showFeedbackModal(data.item)">{{data.item.user_id}}</p>
      </template>

      <template #cell(visitDate)="data">
        {{data.item.visit_date | formatDateTime}}
      </template>

      <template #cell(hostName)="data">
        {{data.item.prisoner_terminal_hostname || '-'}}
      </template>

      <template #cell(pauses)="data">
        {{data.item.call_pauses || '-'}}
      </template>
    </b-table>

    <b-row class="p-1">
      <b-col md="6" class="m-1" v-if="totalRows > limit">
        <b-pagination :total-rows="totalRows" :per-page="limit" v-model="currentPage" class="my-0"/>
      </b-col>
      <p v-if="totalRows === 0" class="col-6 ml-2 my-1">No Feedback available</p>
    </b-row>

    <b-modal class="modal-visitor-feedback" :id="modalName" title="User feedback" hide-footer>
      <visitor-feedback-details  v-if="selectedFeedback" :feedback="selectedFeedback"></visitor-feedback-details>
    </b-modal>

  </b-card>
</template>
<!-- eslint-enable -->

<script>
  import Papa from 'papaparse';
  import moment from 'moment';
  import { mapState } from 'vuex';
  import BiStatsService from '../../../services/BiStatsService';
  import VisitorFeedbackDetails from './VisitorFeedbackDetails.vue';

  export default {
    components: {
      VisitorFeedbackDetails,
    },
    props: {
      filters: {
        required: true,
        type: Object,
      },
    },
    data() {
      return {
        feedback: [],
        headers: [
          { label: 'User ID', key: 'name' },
          { label: 'Prison', key: 'prison' },
          { label: 'Visit Date', key: 'visitDate' },
          { label: 'Hostname', key: 'hostName' },
          { label: 'Call Pauses', key: 'pauses' },
          { label: 'Rating', key: 'rating' },
        ],
        limit: 10,
        currentPage: 1,
        perPage: 10,
        totalRows: 10,
        selectedFeedback: null,
        reportCSV: [],
        reportCSVPage: 1,
        reportLoading: false,
        modalName: 'modal-name',
      };
    },
    computed: {
      ...mapState({
        // filters: state => state.stats.filters,
      }),
    },
    watch: {
      currentPage() {
        this.getFeedback();
      },
    },
    mounted() {
      this.modalName = this.getRandomId(8);
      this.getFeedback();
    },
    methods: {
      getFeedback() {
        const filters = {
          ...this.filters,
          limit: this.limit,
          sort: '-visit_date',
          skip: (this.currentPage - 1) * this.limit,
        }

        BiStatsService.getVisitorFeedbackPaginated(filters).then(res => {
          this.totalRows = res.data.count;
          this.formatFeedback(res.data.data);
        }).catch(err => {
          console.log('error getting feedback paginated', err);
          this.$toast.error('Could not get feedback details, please refresh and try again', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        });
      },
      formatFeedback(feedback) {
        this.feedback = [];

        feedback.forEach(item => {
          this.feedback.push({
            prison: item.prison_name || item.prison_id,
            name: item.user_full_name || item.user_id,
            createdAt: item.created_at ? moment(item.created_at).format('DD/MM/YYYY') : '-',
            rating: item.feedback.length > 0 ? item.feedback[0].responses[0] : 'Not rated',
            ...item,
          });
        });
      },
      showFeedbackModal(feedback) {
        this.selectedFeedback = feedback;
        this.$bvModal.show(this.modalName);
      },
      getRandomId(length) {
        const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOP';
        let pass = '';
        // eslint-disable-next-line no-plusplus
        for (let x = 0; x < length; x++) {
          const i = Math.floor(Math.random() * chars.length);
          pass += chars.charAt(i);
        }

        return pass;
      },
      createReport() {
        this.reportLoading = true;
        this.reportCSVPage = 1; // set the first page to one
        this.reportCSV = []; // reset array

        this.getFeedbackForCSV();
      },
      getFeedbackForCSV() {
        const newFilters = { ...this.filters };
        newFilters.limit = 500;
        newFilters.skip = (this.reportCSVPage - 1) * newFilters.limit;

        newFilters.prisonId = this.filters.prisonId === 'All' ? null : this.filters.prisonId;
        newFilters.after = this.filters.after ? moment(this.filters.after).toISOString() : null;
        newFilters.before = this.filters.before ? moment(this.filters.before).toISOString() : null;
        newFilters.sort = this.filters.sort;

        BiStatsService.getVisitorFeedbackFullDetails(newFilters).then(res => {
          this.reportCSV = this.reportCSV.concat(res.data.data); // keep adding since were stacking requests

          if (this.reportCSV.length < res.data.count) {
            this.getMoreFeedbackForCSV();
          } else {
            this.generateReport();
          }
        });
      },
      getMoreFeedbackForCSV() {
        this.reportCSVPage += 1;
        this.getFeedbackForCSV();
      },
      generateReport() {
        const feedbackFormatted = this.reportCSV.map(fb => {
          const flatQuestions = {};
          fb.feedback.forEach(questionFeedback => {
            const questionTitle = questionFeedback.title;
            let allResponses = '-';
            questionFeedback.responses.forEach((response, index) => {
              if (response !== null && response !== ' ' && response !== '') {
                if (index === 0) {
                  allResponses = response;
                } else {
                  allResponses += `, ${response}`;
                }
              }
            });
            flatQuestions[questionTitle] = allResponses;
          });
          let totalPauses = '-';
          if (fb.visit_call_stats && fb.visit_call_stats.total_pauses) {
            totalPauses = fb.visit_call_stats.total_pauses;
          }
          let prisonerRating = '-';
          if (fb.prisoner_feedback && fb.prisoner_feedback.rating) {
            prisonerRating = fb.prisoner_feedback.rating;
          }
          let prisonerFeedback = '-';
          if (fb.prisoner_feedback && fb.prisoner_feedback.reason) {
            prisonerFeedback = fb.prisoner_feedback.reason;
          }
          return {
            prison: fb.prison_name || '-',
            date: fb.visit_date ? moment(fb.visit_date).format('DD/MM/YYYY') : '-',
            user_id: fb.user_id || '-',
            totalPauses,
            prisonerRating,
            prisonerFeedback,
            ...flatQuestions,
          };
        });

        this.exportReport(feedbackFormatted);
      },
      exportReport(feedbackFormatted) {
        const csv = Papa.unparse(feedbackFormatted);
        const hiddenElement = document.createElement('a');
        hiddenElement.href = `data:text/csv;charset=utf-8,${encodeURI(csv)}`;
        hiddenElement.target = '_blank';
        hiddenElement.download = `feedback-${this.filters.after}-${this.filters.before}.csv`;
        document.querySelector('#app').append(hiddenElement);
        hiddenElement.click();
        hiddenElement.remove();

        this.reportLoading = false;
      },
    },
  };
</script>
